module.exports = __webpack_public_path__ + "static/logo_redasa-16e4df387ce566d5bb5738f3428586bb.svg";